<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" v-model="driver" @[reloadEvent(Component)]="refetch" />
  </router-view>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useFetchQuery } from '@/hooks/fetch';
import { syncHeader } from '@/components/structure/navigation/injects';
import type { Driver } from '@/entities/Entities';
import { syncPageBusy } from '@/components/utils/busy/injects';

const route = useRoute();
const { data: driver, loading, refetch } = useFetchQuery<Driver>(`/drivers/${route.params.driverId}`);

syncPageBusy(loading);

const title = computed(() => `${driver.value?.user?.firstName ?? ''} ${driver.value?.user?.lastName ?? ''}`);

const reloadEvent = (component: any) => {
  return component.type.emits?.includes('reload') ? 'reload' : '';
}

syncHeader(driver, (newDriver) => ({
  extraBreadcrumbs: [
    computed(() => ({
      label: title.value,
      link: `/drivers/${driver.value?.id}`,
    })),
  ],
  title: computed(() => ({
    text: title.value,
    link: { name: 'drivers' },
  })),
}));
</script>

<style lang="scss" scoped>
</style>
